<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="view()">
      <v-icon color="blue">find_in_page</v-icon>
    </v-btn>
    <span>View</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    view() {
      this.$emit("view");
    }
  }
};
</script>

<style>
</style>
